import { SIDE } from '@allocab/allocab-commons-shared-types';
import mime from 'mime';

import { useFetchDocumentLink } from '../../hooks/useFetchDocumentLink';
import { t } from '../../services/translation/translation';
import { PrimaryButton } from '../button/PrimaryButton';
import { Spinner } from '../Spinner';

type Props = {
  documentId: string;
  side: SIDE;
  driverKey?: string;
};

export const DocumentPreview = ({ documentId, side, driverKey }: Props) => {
  const { data: documentLink, isLoading } = useFetchDocumentLink(documentId, {
    driverKey,
    side,
  });

  if (isLoading) {
    return (
      <div className="h-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!documentLink) {
    return null;
  }

  const isImage = mime.getType(documentLink.downloadLink.split('?')[0])?.includes('image');

  if (isImage) {
    return (
      <button
        type="button"
        onClick={() => window.open(documentLink.downloadLink)}
        className="block w-full h-full rounded-lg bg-no-repeat bg-contain bg-center"
        style={{ backgroundImage: `url('${documentLink.downloadLink}')` }}
      />
    );
  }

  return (
    <div className="h-full flex items-center justify-center">
      <PrimaryButton text={t('common.open')} onClick={() => window.open(documentLink.downloadLink)} />
    </div>
  );
};
